<template>
  <div class="frontPagination">
    <ul class="frontPagination__list">
      <li v-if="pager.hasPrev()" class="frontPagination__listItem">
          <a :href="pageLink(pager.currentPage - 1)">&lt;</a>
      </li>
      <li v-for="(page, index) in paginationLinks" :key="`page-${index}`" class="frontPagination__listItem">
        <a v-if="page !== '' && page !== pager.currentPage"
           :href="pageLink(page)">
          {{ page }}
        </a>
        <span v-else-if="page === pager.currentPage" class="active">
          {{ page }}
        </span>
        <span v-else>…</span>
      </li>
      <li v-if="pager.hasNext()" class="frontPagination__listItem">
          <a :href="pageLink(pager.currentPage + 1)">&gt;</a>
      </li>
     </ul>
  </div>
</template>

<script>
export default {
    props: {
        pager: {
            required: true
        },
        form: {
            required: false
        },
    },
    methods: {
        pageLink: function(pageNumber) {
            if (this.form) {
                const filteredModel = _.omit(this.form.model, ['limit', 'offset']);
                const params = new URLSearchParams(filteredModel);
                if (pageNumber >= 1) {
                    params.set('page', pageNumber);
                }
                return `${location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;
            } else {
                return pageNumber > 1 ? `${location.pathname}?page=${pageNumber}` : location.pathname;
            }
        },
    },
    computed: {
        paginationLinks: function () {
            const currentPage = this.pager.currentPage;
            const totalPages = this.pager.totalPages;

            let pages = [];
            if (totalPages <= 5) {
                pages = [...Array(totalPages).keys()].map(n => n + 1);
            } else {
                if (currentPage <= 3) {
                    pages = [1, 2, 3, 4, '', totalPages];
                }
                else if (currentPage >= totalPages - 2) {
                    pages = [1, '', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
                }
                else {
                    pages = [1, '', currentPage - 1, currentPage, currentPage + 1, '', totalPages];
                }
            }
            return pages;
        },
    },
};
</script>